import type { EitherTranslatedOrError, SimpleFormatMessage } from 'components/secondaryMarket/shared/Clipboard/types';
import { guessDateFormats, supportedDateFormats, userInputToIsoDate } from 'components/shared/DatePicker/utils';
import { first } from 'lodash-es';

const availableDateFormats = supportedDateFormats();

export const translateDateOnly = <TValue extends string>(
  pastedValue: string,
  formatSimpleMessage: SimpleFormatMessage,
) => {
  const dateFormat = first(guessDateFormats([pastedValue], availableDateFormats));
  if (!dateFormat) {
    const defaultFormat = first(availableDateFormats);
    const error = formatSimpleMessage('moreMenu.pasteFromClipboard.error.canNotDetectDateFormat', {
      value: pastedValue,
      defaultFormat,
    });
    return { status: 'error', error } as EitherTranslatedOrError<TValue>;
  }
  const parsedDate = userInputToIsoDate(pastedValue, dateFormat);
  return { status: 'success', value: parsedDate as TValue } as EitherTranslatedOrError<TValue>;
};
